import { mapState, mapMutations } from 'vuex';
export default {
  computed: {
    ...mapState('account', {
      globalUserInfo: (state) => state.userInfo,
    }),
  },
  watch: {
    globalUserInfo: {
      handler (val, oldVal) {
        console.log('globalUserInfo changed', val, oldVal)
        if (!val || !val.game_account) return
        if (val.game_account !== oldVal.game_account) {
          this.getUserInfo()
          this.onChangeAccount()
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_BIND_ACCOUNT_DIALOG: 'CHANGE_BIND_ACCOUNT_DIALOG',
    }),
    onLogswitch () {
      this.CHANGE_BIND_ACCOUNT_DIALOG(true);
    },
    getUserInfo () {},
    // 变更用户信息后需要更新的内容
    onChangeAccount () {},
  }
}